/**
 * Hook to check if current user has Premium tier access
 * Used for gating Premium-only features like AI Insights Engine v2
 */

import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export function useIsPremiumUser() {
  return useQuery({
    queryKey: ['is-premium-user'],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return false;

      const { data: roles } = await supabase
        .from('user_roles')
        .select('role')
        .eq('user_id', user.id)
        .in('role', ['admin', 'premium']);

      return roles && roles.length > 0;
    }
  });
}
